export default __webpack_public_path__ + "static/media/Co2Emission.4c5667e4.svg";